// Built-in Libraries
import { Link } from 'react-router';

// Custom Hooks

import type { IGetProjectServiceResData } from '@/api/Sherpa/Project/modules/ProjectCore/types';
import ImageCircularAvatar from '@/components/UI/Avatar/ImageCircularAvatar';
// Assets & Miscellaneous
import { formatNumber, getInitials } from '@/utils';

type DrawInfoProps = {
  name: string;
} & Pick<IGetProjectServiceResData, 'projectLead' | 'drawSummary'>;

const DrawInfo = ({ name, projectLead, drawSummary }: DrawInfoProps) => {
  return (
    <div className='grid grid-cols-3 py-5 w-full space-y-4'>
      <div className='col-span-1 flex flex-col justify-between'>
        <h3 className=''>{name} Draw Summary</h3>
        <div className='flex pt-2'>
          <Link to={`/app/administration/users/${projectLead.id}`} className='flex items-center gap-2'>
            <ImageCircularAvatar
              customClass='h-16 w-16'
              imageUrl={projectLead.profileImageUrl}
              fallbackText={getInitials(projectLead.name)}
            />
            <div>
              <p className='font-bold text-lg'>{projectLead.name}</p>
              <p className='text-neutralColor-normal'>Project Lead</p>
            </div>
          </Link>
        </div>
      </div>
      <div className='col-span-2 relative border-t py-4 xl:border-l xl:border-t-0 lg:p-4 justify-around w-full flex md:flex-row gap-20'>
        <div className='space-y-4'>
          <div className='text-center md:text-left'>
            <p className='text-primaryColor-normal'>Total Approved Documents: {formatNumber(drawSummary.approvedDocuments)}</p>
          </div>
          <div className='text-center md:text-left'>
            <p className='text-primaryColor-normal'>Total Approved Invoices: {formatNumber(drawSummary.approvedInvoices)}</p>
          </div>
        </div>
        <div className='space-y-4'>
          <div className='text-center md:text-left'>
            <p className=''>Total Documents: {formatNumber(drawSummary.submittedDocuments)}</p>
          </div>
          <div className='text-center md:text-left'>
            <p className=''>Total Invoices: {formatNumber(drawSummary.submittedInvoices)}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DrawInfo;
